function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m-23791.549-18819.576 9.27-6.717 9.139 6.717v13.139l-18.408-.125z",
  "data-name": "Path 406",
  style: {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: "1.3px"
  },
  transform: "translate(23798.352 18832.293)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-23755.221-18813.455h6.219",
  "data-name": "Path 421",
  style: {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: "1.3px"
  },
  transform: "translate(23768.221 18833.107)"
}));
export default SvgIconHome;